import { extractSubSpecialties } from 'doctify-utils';
import uniqBy from 'lodash/uniqBy';

export const transformListingsForExpandedDropdown = (listings = {}, requiredTopLevelSpecialtiesNames = []) => {
    const sortOrderFilter = (item) => (item.sort_order >= 0);
    const itemTransformer = (item) => ({...item, type: item.keyword_type});

    const otherKeywords = extractSubSpecialties(listings.conditions.concat(listings.procedures));

    const listingsTopLevelSpecialties = listings.topLevelSpecialties || [];

    let topLevelSpecialties;

    if (requiredTopLevelSpecialtiesNames.length > 0) {
        topLevelSpecialties = requiredTopLevelSpecialtiesNames
            .map(name => listingsTopLevelSpecialties.find(item => item.name === name))
            .filter(Boolean);

    } else {
        topLevelSpecialties = listingsTopLevelSpecialties.filter(sortOrderFilter);
    }

    topLevelSpecialties = topLevelSpecialties
        .map(itemTransformer)
        .map(item => ({...item, isTopLevelSpecialty: true}));

    const relatedKeywords = uniqBy(topLevelSpecialties.reduce((accumulator, specialty) => {
        return accumulator.concat(otherKeywords.filter(kw => kw.parent_id === specialty.id).map(itemTransformer));
    }, []), 'id');


    const specialists = listings.specialists || [];
    return [
        ...topLevelSpecialties,
        ...relatedKeywords,
        ...specialists,
    ];
};



// WEBPACK FOOTER //
// ./src/client/utils/transformers/transformListingsForExpandedDropdown.js